import axios from '@/utils/request'

export default {
  getAdPopupsList: data => axios({ url: '/api/message/popupList', method: 'post', data }), // 获取页面弹窗列表
  addAdPopups: data => axios({ url: '/api/message/popup', method: 'post', data }), // 获取页面弹窗列表
  getAdPopupsDetail: id => axios({ url: `/api/message/popup/${id}`, method: 'get' }), // 获取页面弹窗详情
  deleteAdPopups: id => axios({ url: `/api/message/popup/${id}`, method: 'delete' }), // 获取页面弹窗列表
}